import React, {Component} from 'react';
import { connect } from 'react-redux';
import axios from '../../axios-orders';

import Aux from "../../hoc/Aux/Auxillary";
import Burger from "../../components/Burger/Burger";
import BuildControls from "../../components/Burger/BuildControls/BuildControls";
import Modal from "../../components/UI/Modal/Modal";
import OrderSummary from "../../components/Burger/OrderSummary/OrderSummary";
import Spinner from "../../components/UI/Spinner/Spinner";
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler.js';
import * as actions from '../../store/actions/index';


export class BurgerBuilder extends Component {

	// constructor(props) {
	// 	super(props);
	// 	this.state = {..}
	// }
	state = {
		purchasing: false,
	}

	componentDidMount () {
	 	console.log(this.props);
	 	this.props.onInitIngredients();
		
	}

	updatePurchaseState (ingredients) {
		const sum = Object.keys(ingredients)
					.map(igKey => {
						return ingredients[igKey];
					})
					.reduce((sum, el) => {
						return sum + el;
					},0);
		return sum > 0;
	}

	purchaseHandler = () => {
		if(this.props.isAuthenticated) {
			this.setState({purchasing: true});
		}
		else {
			this.props.onSetAuthRedirectPath('/checkout');
			this.props.history.push('/auth');
		}
	}

	purchaseCancelHandler = () => {
		this.setState({purchasing: false});
	}

	purchaseContinueHandler = () => {
		//alert('You continue');
		this.props.onInitPurchase();
		this.props.history.push('/checkout');

	}
 	//lifecycle method to implement
	render() {

		const disableInfo = {
			...this.props.ings
		};

		for(let key in disableInfo) {
			disableInfo[key] = disableInfo[key] <=0 //returns true or false
			//{salad:true, meat:false...}
		}

		let orderSummary = null;
		
		let burger = this.props.error ? <p>Something went wrong!</p> : <Spinner />;

		//console.log('Hello');
		
		if(this.props.ings) {
			//console.log(this.props.ings);
			//console.log('Inside if statement');
			burger = (
				<Aux>
					<Burger ingredients={this.props.ings}/>
					<BuildControls 
						ingredientAdded = {this.props.onIngredientAdded}
						ingredientRemoved = {this.props.onIngredientRemoved}
						disabled = {disableInfo}
						price = {this.props.price}
						purchasable = {this.updatePurchaseState(this.props.ings)}
						ordered={this.purchaseHandler} 
						isAuth = {this.props.isAuthenticated}/> 
				</Aux>
			);
			orderSummary = <OrderSummary 
							ingredients={this.props.ings}
							price={this.props.price}
							purchaseCancelled={this.purchaseCancelHandler}
							purchaseContinued={this.purchaseContinueHandler} />;		
		}

		
		return(
		//returns some jsx code
		//wrap it in hoc
		<Aux>
			<Modal show={this.state.purchasing} modalClosed={this.purchaseCancelHandler}> 
				{orderSummary}
			</Modal>
			{burger}
		</Aux>

		);
	}
}

const mapStateToProps = state => {
	return {
		ings: state.burgerbuilder.ingredients,
		price: state.burgerbuilder.totalPrice,
		error: state.burgerbuilder.error,
		isAuthenticated: state.auth.token !== null
	};
}

const mapDispatchToProps = dispatch => {
	return {
		onIngredientAdded: (ingName) => dispatch(actions.addIngredient(ingName)),
		onIngredientRemoved: (ingName) => dispatch(actions.removeIngredient(ingName)),
		onInitIngredients: () => dispatch(actions.initIngredients()),
		onInitPurchase: () => dispatch(actions.purchaseInit()),
		onSetAuthRedirectPath: (path) => dispatch(actions.setAuthRedirectPath(path))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(BurgerBuilder, axios));



// WEBPACK FOOTER //
// ./src/containers/BurgerBuilder/BurgerBuilder.js